import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCuteRobot: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCuteRobot"><Path fillRule="evenodd" clipRule="evenodd" d="M12.7501 1V3H19.9689V14H19.0608L21.3108 16.25L20.2501 17.3107L18.9305 15.991C18.4491 19.3877 15.5297 22 12.0001 22C8.47054 22 5.5511 19.3877 5.06973 15.991L3.75011 17.3107L2.68945 16.25L4.93945 14H4.03136V3H11.2501V1H12.7501ZM5.53136 12.5H18.4689V4.5H5.53136V12.5ZM9.50011 7V10H8.00011V7H9.50011ZM16.0001 7V10H14.5001V7H16.0001Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCuteRobot;
